import React from 'react'
import { noop } from 'lodash'

/**
 * @typedef {object} ActionCellProps
 * @property {number} [rowIndex]
 * @property {object} definition - must have `actions` array of render functions
 * @property {Array} [data]
 * @property {string} primaryKeyField
 * @property {Function} [onRowAction]
 * @property {Array} [userAuthorities]
 */
import { Cell } from 'fixed-data-table-2'
import classnames from 'classnames/bind'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const ActionCell = _props => {
  const {
    rowIndex,
    data,
    definition,
    primaryKeyField,
    onRowAction = noop,
    userAuthorities = [],
    ...props
  } = _props

  const renderButtons = () => {
    return definition.actions.map((action, index) =>
      action(
        index,
        rowIndex,
        data[rowIndex][primaryKeyField],
        data[rowIndex],
        onRowAction,
        userAuthorities
      )
    )
  }

  return (
    <Cell data-elm-id={`actions_${rowIndex}`} className={cx('cell')} {...props}>
      {renderButtons()}
    </Cell>
  )
}

export default ActionCell
